// Rezolvă URL-ul logo-ului în funcție de tema curentă, cu fallback pe varianta
// existentă dacă cealaltă lipsește. Returnează null dacă firma nu are niciun logo.
export const resolveCompanyLogo = (company, theme) => {
  if (!company) return null;
  const { logoLight, logoDark } = company;
  if (theme === 'dark') return logoDark || logoLight || null;
  return logoLight || logoDark || null;
};

// Dacă logo-ul nu are variantă dedicată pe tema curentă, e util să-l punem pe un
// fundal neutru deschis ca să rămână lizibil pe dark (cazul clasic: logo color
// livrat doar ca variantă light și afișat în dark mode).
export const needsLightBackdrop = (company, theme) => {
  if (!company || theme !== 'dark') return false;
  return !!company.logoLight && !company.logoDark;
};

// URL absolut — fișierele sunt servite de backend la /uploads/logos/...
// REACT_APP_API_URL include /api, deci tăiem /api ca să ajungem la root.
export const logoUrl = (relativePath) => {
  if (!relativePath) return null;
  if (relativePath.startsWith('http')) return relativePath;
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  const base = apiUrl.replace(/\/api\/?$/, '');
  return `${base}${relativePath}`;
};
